import markerRed from "../../images/icon/pin-red.svg";
import markerViolet from "../../images/icon/pin-violet.svg";

export default class Map {
  constructor({selector, data, googleMapsStylingOptions}) {
    this.mapElement = document.querySelector(selector);
    if (typeof google === 'undefined') return new Error('Core google maps api code is not loaded!');
    if (typeof selector === 'undefined') return new Error('Wrong selector: ' + selector);
    if (!this.mapElement) return new Error('Wrong selector: ' + selector);

    // template options
    this.listWrapper = document.querySelector('.search-result__list');
    this.searchField = document.querySelector('.sidebar-map .search input[type="search"]');
    this.tagCheckboxes = document.querySelectorAll('.sidebar-map .search-result__filter input[type="checkbox"]');
    let btnClose = document.querySelector('.sidebar-map .search .search-result .close');
    let categoriesListItems = document.querySelectorAll('.sidebar-map .default ul > li');

    // main options
    this.dataList = data;
    this.dynamicDataList = this.dataList;
    this.map = null;
    this.bounds = {
      default: {},
      search: {},
      preview: {}
    };
    this.markers = [];
    this.tags = [];
    this.currentPlace = {};

    // styling options
    this.googleMapsCenter = this.mapElement.dataset.center && JSON.parse(this.mapElement.dataset.center);
    this.googleMapsStylingOptions = googleMapsStylingOptions;

    // show initial state when search field empty
    this.searchField.addEventListener("keyup", (e) => {
      if (!e.target.value.length) this.setState('default');
    });

    // switch markers visibility
    Array.prototype.forEach.call(this.tagCheckboxes, el => {
      this.tags.push(el.name);

      el.addEventListener('change', (e) => {
        let name = e.target.name;
        let isChecked = e.target.checked;

        if (isChecked) {
          if (!this.tags.includes(name)) this.tags.push(name)
        } else {
          if (this.tags.includes(name)) this.tags = this.tags.filter(el => el !== name)
        }

        this.toggleVisibleMarkers(this.tags);
        this.updateList();
      });
    });

    Array.prototype.forEach.call(categoriesListItems, el => {
      el.addEventListener('click', e => {
        let category = e.currentTarget.dataset.category;
        this.searchField.value = '';
        this.tags = [category];

        Array.prototype.forEach.call(document.querySelectorAll('.search-result__filter input:not([name=' + category + '])'), el => {
          el.checked = false;
        });

        document.querySelector('input[name=' + category + ']').checked = true;
        this.toggleVisibleMarkers(category);
        this.setState(this.searchField.value ? 'preview' : 'search');
        this.updateList();
      })
    });

    btnClose.addEventListener('click', () => {
      this.setState('default');
      this.updateList();
    });

    this.init();
  }

  init() {
    String.prototype.clean = function () {
      return this.replace('\\n', '<br>').replace('\n', '<br>')
    };

    this.createMap();
    this.setMarkers(this.dataList);
    this.autocomplete();
  }

  setState(stateName) {
    let searchWrapper = document.querySelector('.sidebar-map .search');
    let searchResultWrapper = document.querySelector('.sidebar-map .search-result');
    let previewWrapper = document.querySelector('.sidebar-map .preview');
    let defaultWrapper = document.querySelector('.sidebar-map .default');

    if (stateName === 'default') {
      defaultWrapper.classList.remove('d-none');
      searchResultWrapper.classList.add('d-none');
      previewWrapper.classList.remove('active');
      searchWrapper.classList.remove('d-none');
      this.searchField.value = '';
      this.dynamicDataList = [];
      this.showAllMarkers();
    }

    if (stateName === 'search') {
      defaultWrapper.classList.add('d-none');
      searchResultWrapper.classList.remove('d-none');
      previewWrapper.classList.remove('active');
      searchWrapper.classList.remove('d-none');

      if (!this.searchField.value) {
        this.dynamicDataList = [];
      }

      this.updateList();
    }

    if (stateName === 'preview') {
      defaultWrapper.classList.add('d-none');
      searchResultWrapper.classList.add('d-none');
      previewWrapper.classList.add('active');
      searchWrapper.classList.add('d-none');
    }

    this.map.fitBounds(this.bounds[stateName]);
  }

  updateList() {
    let data = this.searchField.value ? (this.dynamicDataList.length ? this.dynamicDataList : this.dynamicDataList) : this.dataList;

    let filterTags = this.tags;
    let filtered = this.sortByCountry(this.filterByTags(filterTags, data));

    this.listWrapper.innerHTML = this.createList(filtered);

    this.listWrapper.addEventListener('click', (e) => {
      if (e.target.tagName === "LI" && !e.target.classList.contains('nothing')) {
        this.previewItem(data, e.target.dataset.id);

        this.setState('preview');

        let marker = this.getMarkerById(e.target.dataset.id);
        let map = this.map;
        map.panTo(marker.getPosition());
        map.setZoom(16);
        this.bounds.preview.extend(map.getCenter());
      }
    });


    this.listWrapper.addEventListener('mouseover', (e) => {
      const source = (this.dynamicDataList && this.dynamicDataList.length)
        ? this.dynamicDataList
        : this.dataList;
      Array.prototype.forEach.call(source, _el => {
        let el = this.getMarkerById(_el.id);
        el.setOptions({
          opacity: 1,
          zIndex: 10,
          icon: {
            url: el.getIcon().url,
            scaledSize: new google.maps.Size(24, 36),
            anchor: new google.maps.Point(12, 36),
          }
        });
      });

      if (e.target.tagName === "LI" && !e.target.classList.contains('nothing')) {
        let el = this.getMarkerById(e.target.dataset.id);
        el.setOptions({
          opacity: 1,
          zIndex: 100,
          icon: {
            url: el.getIcon().url,
            scaledSize: new google.maps.Size(36, 54),
            anchor: new google.maps.Point(18, 54),
          }
        });
      }
    });

    this.listWrapper.addEventListener('mouseout', (e) => {
      Array.prototype.forEach.call(this.dynamicDataList, _el => {
        let el = this.getMarkerById(_el.id);
        el.setOptions({
          opacity: 1,
          zIndex: 10,
          icon: {
            url: el.getIcon().url,
            scaledSize: new google.maps.Size(24, 36),
            anchor: new google.maps.Point(12, 36),
          }
        });
      });
    });
  }

  static createPreviewItem(data) {
    if (!data) return;

    return `
      <span class="link-back"></span>

      ${data.logoUri && data.website ? '<a target="_blank" href="http://' + data.website + '"><img src="' + data.logoUri + '" alt="logo" class="logo"></a>' : ''}
      ${data.logoUri && !data.website ? '<img src="' + data.logoUri + '" alt="logo" class="logo">' : ''}

      <h3 class="preview__name">
        ${data.name.clean()}
      </h3>

      <h4 class="preview__address">
        ${data.address.street.clean()}, ${data.address.postalCode} ${data.address.city.clean()}, ${data.address.country.clean()}
      </h4>

      <div class="preview__contacts">
        ${data.telephone ? '<div><span class="label">TEL</span><a href="tel:' + data.telephone + '" class="value">' + data.telephone + '</a></div>' : ''}
        ${data.email ? '<div><span class="label">EMAIL</span><a href="mailto:' + data.email + '" class="value">' + data.email + '</a></div>' : ''}
        ${data.website ? '<div><span class="label">WEB</span><a target="_blank" href="http://' + data.website + '" class="value">' + data.website + '</a></div>' : ''}
      </div>

      <a target="_blank" href="https://maps.google.com/maps?ll=${data.latitude},${data.longitude}&z=16&t=m&hl=de&gl=AT&mapclient=embed&daddr=@${data.latitude},${data.longitude}" class="btn-square">Route berechnen</a>`;
  }

  previewItem(data, id) {
    let el = data.find(el => el.id === id);
    let previewWrapper = document.querySelector('.sidebar-map .preview');

    previewWrapper.innerHTML = Map.createPreviewItem(el);

    let btnBack = previewWrapper.querySelector('.link-back');
    if (btnBack) {
      btnBack.addEventListener('click', () => {
        this.setState(this.searchField.value ? 'search' : 'default');
        let map = this.map;
        map.fitBounds(this.bounds.search)
      })
    }
  }

  createListItem(data) {
    if (!data) return;
    let distance;
    if (data.distance) {
      distance = Math.round((data.distance + Number.EPSILON) * 100) / 100;
      distance = distance > 1 ? distance + ' km' : distance * 1000 + ' m';
    }

    let categoryColor = 'red';
    if (data.categories.includes('isInteriorDesigner') && this.tags.includes('isInteriorDesigner')) categoryColor = 'violet';
    if (data.categories.includes('isFurnitureSpecialistShop') && this.tags.includes('isFurnitureSpecialistShop')) categoryColor = 'red';

    return `
      <li data-id="${data.id}">
        <svg xmlns="http://www.w3.org/2000/svg" width="24.333" height="35.796" viewBox="0 0 24.333 35.796">
          <g transform="translate(0.5 0.5)">
            <path class="pin-${categoryColor}" d="M11.667,34.436S23.333,18.11,23.333,11.667A11.667,11.667,0,1,0,0,11.667C0,18.11,11.667,34.436,11.667,34.436Z" transform="translate(0 0)" stroke="#f4f4f4" stroke-miterlimit="10" stroke-width="1"></path>
            <circle cx="5.833" cy="5.833" r="5.833" transform="translate(5.833 5.833)" fill="#f4f4f4"></circle>
          </g>
        </svg>

        <div>
          <p class="search-result__name">${data.name.clean()}</p>
          <p class="search-result__address">${data.address.street.clean()}, ${data.address.postalCode.clean()} ${data.address.city.clean()}, ${data.address.country.clean()}</p>
          ${data.distance && this.searchField.value ? '<p class="search-result__distance">' + distance + '</p>' : ''}
        </div>
      </li>`;
  }

  createList(data) {
    let list = '';
    let sortByDistance = (a, b) => a.distance === b.distance ? 0 : a.distance < b.distance ? -1 : 1;

    data = data.filter(a => a.address.countryCode === "A").sort(sortByDistance).concat(data.filter(a => a.address.countryCode !== "A").sort(sortByDistance));

    if (data.length === 0) return '<li class="nothing">Kein passender Händler gefunden.</li>';

    Array.prototype.forEach.call(data, el => {
      list += (this.createListItem(el));
    });

    return list;
  }

  createMarker(position, categories, map, id) {
    let color = 'red';
    if (categories.includes('isInteriorDesigner')) color = 'violet';
    if (categories.includes('isFurnitureSpecialistShop')) color = 'red';

    let marker = new google.maps.Marker({
      position: position,
      icon: {
        url: color === "red" ? markerRed : markerViolet,
        scaledSize: new google.maps.Size(24, 36),
        anchor: new google.maps.Point(12, 36)
      },
      optimized: false,
      map: map
    });

    marker.metadata = {categories: categories, id: id};

    marker.addListener('click', () => {
      this.bounds.preview.extend(marker.getPosition());
      this.previewItem(this.dataList, marker.metadata.id);
      this.setState('preview');

      if (window.innerWidth <= 992) {
        window.scrollTo({
          'behavior': 'smooth',
          'left': 0,
          'top': document.querySelector('main').offsetTop - document.querySelector('header').clientHeight
        });
      }

      map.setZoom(16);
      map.panTo(marker.getPosition());
    });

    // Add mouseover event to enlarge marker
    marker.addListener('mouseover', () => {
      marker.setOptions({
        icon: {
          url: marker.getIcon().url,
          scaledSize: new google.maps.Size(29, 43),
          anchor: new google.maps.Point(15, 43)
        }
      });
    });

    // Add mouseout event to restore original size
    marker.addListener('mouseout', () => {
      marker.setOptions({
        icon: {
          url: marker.getIcon().url,
          scaledSize: new google.maps.Size(24, 36),
          anchor: new google.maps.Point(12, 36)
        }
      });
    });

    this.markers.push(marker);

    return marker;
  }

  autocomplete() {
    let bounds;
    let input = document.getElementById('searchTextField');
    let options = {types: ['(regions)']};
    let autocomplete = new google.maps.places.Autocomplete(input, options);

    google.maps.event.addListener(autocomplete, 'place_changed', () => {
      let place = autocomplete.getPlace();
      this.dynamicDataList = [];

      if (place.geometry) {
        this.currentPlace = place.geometry.location;


        // For each place, get the icon, name and location.
        bounds = new google.maps.LatLngBounds();

        // map fit city/country
        if (place.geometry.viewport) {
          bounds.union(place.geometry.viewport);
        } else {
          bounds.extend(place.geometry.location);
        }

        this.bounds.search = bounds;
        this.dynamicDataList = this.sortByCountry(this.searchByLocation(place.address_components[0].long_name));

        // nothing found
        if (!this.dynamicDataList.length) {
          this.bounds.search = new google.maps.LatLngBounds();
          let markers = this.markers.filter(m => this.getDistance(m) < 50);
          Array.prototype.forEach.call(markers, marker => {
            this.bounds.search.extend(marker.getPosition())
            this.dynamicDataList.push(this.getItemById(marker.metadata.id));
          });
        }

        if (!place.geometry) {
          console.log("Returned place contains no geometry");
          return;
        }

        this.listWrapper.innerHTML = this.createList(this.filterByTags(this.tags, this.dynamicDataList));

        if (input.value.length) {
          this.setState('search');
          this.hideOtherMarkers(this.filterByTags(this.tags, this.dynamicDataList));
          // calculate and set items distance from search value (center).
          this.setDistances();
          this.bounds.search = this.map.getBounds();
        }
      }
    });
  }

  // get distance between map center and marker
  getDistance(marker) {
    return google.maps.geometry.spherical.computeDistanceBetween(this.currentPlace, marker.position) / 1000;
  }

  // set items distance
  setDistances() {
    let markers = this.getVisibleMarkers();

    Array.prototype.forEach.call(markers, marker => {
      let item = this.getItemById(marker.metadata.id);

      item.distance = this.getDistance(marker)
    });

    this.updateList();
  }


  // initial methods
  createMap() {
    if (!this.mapElement) return new Error('No such element: ' + this.mapElement);

    this.map = new google.maps.Map(this.mapElement, {
      center: this.googleMapsCenter,
      zoom: 9,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
      options: this.googleMapsStylingOptions
    });
  }

  setMarkers(data) {
    if (!this.mapElement) return;

    let map = this.map;

    if (!data.length) return;
    this.bounds.default = new google.maps.LatLngBounds();

    Array.prototype.forEach.call(data, el => {
      let position = {lat: parseFloat(el.latitude), lng: parseFloat(el.longitude)};
      let marker = this.createMarker(position, el.categories, map, el.id);
      marker.set('visible', true);
      this.bounds.default.extend(marker.position);
    });

    this.bounds.search = this.bounds.preview = this.bounds.default;

    if (Object.keys(this.bounds.default).length) {
      map.fitBounds(this.bounds.default);
      this.currentPlace = map.getCenter();
    }
  }


  // marker manipulation methods
  hideOtherMarkers(data) {
    data = data || this.dynamicDataList;
    Array.prototype.forEach.call(this.markers, marker => {
      marker.set('visible', false);
    });

    Array.prototype.forEach.call(data, el => {
      let marker = this.getMarkerById(el.id);
      if (marker) {
        marker.set('visible', true);
      }
    });
  }

  showAllMarkers() {
    Array.prototype.forEach.call(this.markers, marker => {
      marker.set('visible', true);
    });
  }

  toggleVisibleMarkers(type) {
    let data = this.dynamicDataList.length ? this.dynamicDataList : this.dataList;
    this.hideOtherMarkers(this.filterByTags(this.tags, data));
  }


  // main getters
  getMarkerById(id) {
    return this.markers.find(m => m.metadata.id === id);
  }

  getItemById(id) {
    return this.dataList.find(d => d.id === id);
  }

  getVisibleMarkers() {
    return this.markers.filter(m => m.get('visible') === true);
  }


  // list operations
  sortByCountry(data) {
    data = data || this.dynamicDataList || this.dataList;
    return data.sort(a => a.address.countryCode === "A" ? -1 : 1);
  }

  searchByLocation(value, type = 'city') {
    let data = this.dataList;
    return data.filter(el => el.address[type].indexOf(value) === 0);
  }

  filterByTags(tags, data) {
    data = data || this.dataList;
    return data.filter(el => el.categories.some(category => tags.includes(category)));
  }
}
